export function onlyDigitsWithMaxLen(max) {
  return event => {
    if (event.key === "Backspace" || event.key === "Delete" || event.key === "Enter" || event.key === "Tab") return

    if ((event.ctrlKey || event.metaKey) && (event.keyCode === 86 || event.keyCode === 88 || event.keyCode === 67))
      return

    const val = remSep(event.target.value)

    if (val.length >= max) {
      return event.preventDefault()
    }
    const persianKey = p2e(event.key)
    if (!/[0-9]/.test(persianKey)) {
      event.preventDefault()
    }
  }
}


export function onlyDigitsAndSlashWithMaxLen(max) {
  return event => {
    if (event.key === "Backspace" || event.key === "Delete" || event.key === "Enter" || event.key === "Tab") return

    if ((event.ctrlKey || event.metaKey) && (event.keyCode === 86 || event.keyCode === 88 || event.keyCode === 67))
      return

    const val = remSep(event.target.value)

    if (val.length >= max) {
      return event.preventDefault()
    }
    const persianKey = p2e(event.key);

    if (!/[0-9/]/.test(persianKey)) {
      event.preventDefault()
    }
  }
}

export function onlyCharactersWithMaxLen(max) {
  return event => {
    if (event.key === "Backspace" || event.key === "Delete" || event.key === "Enter" || event.key === "Tab") return
    if ((event.ctrlKey || event.metaKey) && (event.keyCode === 86 || event.keyCode === 88 || event.keyCode === 67))
      return

    const val = remSep(event.target.value)

    if (val.length >= max) {
      return event.preventDefault()
    }
    const persianKey = p2e(event.key);

    if (!/[[a-zA-Z0-9/]/.test(persianKey)) {
      event.preventDefault()
    }
  }
}

export function OnlyEnglishCharacter() {
  return event => { 
      const val = event.key;
      if (!/[[a-zA-Z]/.test(val)) {
        event.preventDefault()
      }
  }
}

// export const commaSep = (num) => (num + "").split("").reverse().map((v, i) => (i % 3) ? v : v + ",").join("").slice(1)
export const commaSep = num => (typeof num === "number" ? p2e(num) : +p2e(num).replace(/\D/g, "")).toLocaleString()
//export const remSep = value => value.replace(/\D/g, "")
// export const p2e = s => s.replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
export const remSep = value => {
   return typeof value === "string" ? value.replace(/\D/g, "") : value;
}

export const p2e = s => {
  return typeof s === "string" ? s.replace(/[۰-۹]/g, d => "۰۱۲۳۴۵۶۷۸۹".indexOf(d)) : s;
}
